import React from "react";
import { useSupportChat } from "../contexts/SupportChatContext";

const IntercomChatButton: React.FC = () => {
  const { show, hide, isOpen, status } = useSupportChat();

  const handleClick = () => {
    if (isOpen) {
      hide();
    } else {
      show();
    }
  };

  return (
    <button
      onClick={handleClick}
      aria-busy={status === "auth-resolving" || status === "transitioning"}
      disabled={status === "unavailable"}
      title={status === "unavailable" ? "Support chat is unavailable" : undefined}
      className={[
        "px-4 py-1.5 rounded-lg",
        "bg-rp-amber border-2 border-black text-black",
        "shadow-[0_0_12px_rgba(0,0,0,0.3)]",
        "hover:shadow-[0_0_20px_rgba(0,0,0,0.5)]",
        "dark:bg-black dark:border-2 dark:border-rp-amber dark:text-rp-amber",
        "dark:shadow-[0_0_12px_rgba(204,122,0,0.3)]",
        "dark:hover:shadow-[0_0_20px_rgba(204,122,0,0.5)]",
        "transition-all duration-200 ease-out",
        "text-sm font-semibold tracking-wide",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-rp-amber focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-offset-black",
      ].join(" ")}
      aria-label={status === "support-error" ? "Retry support chat" : isOpen ? "Close support chat" : "Open support chat"}
    >
      {status === "transitioning" ? "Connecting support..." : status === "support-error" ? "Retry support" : "Need Help?"}
    </button>
  );
};

export default IntercomChatButton;
